module.exports = __webpack_public_path__ + "static/wp-marketing-tools-alt-f21ef466def0c821cfd7f7d042b371a1.webp";